module.exports = __webpack_public_path__ + "img/collar buttons quantity.85ae697f.png";